import { Modal } from "antd";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { storeProductSelector } from "../../../../services/selector/index.";
import BaseButton from "../../Button/BaseButton";
import TranslateText from "../../TranslateText";
import "../../../../assets/style/modalStyle/delete.scss";
import { setOpenModalConfirm } from "../../../../services/slice/StoreSlice";
import { useTranslation } from "react-i18next";

const ModalConfirmStoreStatus = ({
  width,
  handleConfirm,
  title = "Xác nhận",
  content,
}) => {
  const stateStore = useSelector(storeProductSelector);
  const { isOpenModalConfirm } = stateStore;
  const dispatch = useDispatch();
  const handleCancel = () => {
    dispatch(setOpenModalConfirm(false));
  };
  const { t } = useTranslation();
  return (
    <>
      <Modal
        maskClosable={false}
        title={<TranslateText text={title} />}
        centered
        open={isOpenModalConfirm}
        className="warrperModalDelete"
        footer={[
          <div className="evenSpace">
            <BaseButton
              content={"Hủy bỏ"}
              typeBtn="mainBtn btnCancel"
              width={155}
              handleClick={handleCancel}
            />

            <BaseButton
              width={155}
              content={"Đồng ý"}
              typeBtn="btnOrange"
              handleClick={handleConfirm}
            />
          </div>,
        ]}
        width={width}
        onCancel={handleCancel}
      >
        {content === t("Còn hàng") ? (
          <p style={{ fontSize: 20, textAlign: "center" }}>
            <TranslateText text="Sản phẩm này đã hết hàng trong kho?" />{" "}
          </p>
        ) : (
          <p style={{ fontSize: 20, textAlign: "center" }}>
            <TranslateText text={"Sản phẩm này đã được bổ sung vào kho?"} />
          </p>
        )}
      </Modal>
    </>
  );
};

export default ModalConfirmStoreStatus;
